import React, { useMemo } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { UITrack } from "../../firebase/firestore";
import useAuth from "../../hooks/useAuth";
import { mutateWhere } from "../../utils/arrays";
import { TrackRow } from "../track/TrackRow";
import { GlobalSelectionActions } from "./PackList";
import { PackTracksProps } from "./PackTitle";

export default function PackTracks({
  tracks,
  customAddTracksMessage,
  canSelect,
  setTracks,
  onDelete,
  canEdit,
  canEditOwnTracks,
  creator,
  canAdd,
  onAdd,
  showTrackAuthors,
  cantAddMessage,
  pack,
}: PackTracksProps) {
  const { allSelected, toggleAll, deleteSelected, selectTrack, deselectTrack } = useTracksSelect(
    setTracks,
    tracks,
    onDelete
  );

  const { user } = useAuth();

  return (
    <div className="track-con grow w-full md:w-auto track-con " style={{ zIndex: 10 }}>
      {canEdit && (
        <GlobalSelectionActions
          someSelected={tracks.some((t) => t.selected)}
          allSelected={allSelected}
          toggleAll={toggleAll}
          onDelete={deleteSelected}
        />
      )}
      <div className="overflow-y-auto " style={{ maxHeight: "40vh" }}>
        {tracks.map((uiTrack, idx) => (
          <TrackRow
            uiTrack={uiTrack}
            key={`packtrack-${uiTrack.track.id}`}
            playable={"inline"}
            selectable={canSelect}
            selected={canSelect ? uiTrack?.selected || false : false}
            onSelect={canSelect && (() => selectTrack(uiTrack))}
            onDeselect={canSelect && (() => deselectTrack(uiTrack))}
            {
              ...{} /* @ts-ignore */
            }
            editable={canEdit || (canEditOwnTracks && user?.uid === uiTrack?.track?.creator?.id)}
            creator={creator}
            idx={idx + 1}
            onDelete={
              (canEdit || (canEditOwnTracks && user?.uid === uiTrack?.track?.creator?.id)) && (() => onDelete(uiTrack))
            }
            showCreator={showTrackAuthors}
            // actions={generateActions(uiTrack)}
            {
              ...{} /* @ts-ignore */
            }
            uploadProgress={uiTrack?.progress}
            className="-mr-24"
            pack={pack}
          />
        ))}
      </div>
      <div className="flex justify-center m-auto text-light-gray text-lg " onClick={onAdd}>
        <div className="relative mt-12">
          {canAdd && (
            <div className="cursor-pointer hover:underline">
              <AiOutlinePlus className=" absolute right-full top-1/2 -translate-y-1/2 mr-2" />{" "}
              {customAddTracksMessage || "Add tracks"}
            </div>
          )}
          {!canAdd && cantAddMessage}
        </div>
      </div>

      {/* {canAdd && <AiOutlinePlus className='opacity-0 hover:opacity-100 plus  transition-opacity w-6 h-6 m-2 cursor-pointer' onClick={onAdd} />} */}
    </div>
  );
}

export function useTracksSelect(
  setTracks: React.Dispatch<React.SetStateAction<UITrack[]>>,
  tracks: UITrack[],
  onDelete: (uiTrack: UITrack) => any
) {
  const mutateTrack = (uiTrack: UITrack, mutate: (t: UITrack) => UITrack) => {
    console.log("mutating", uiTrack);
    setTracks(mutateWhere(tracks, mutate, (t) => t === uiTrack || t.track.path === uiTrack.track.path));
  };
  const selectTrack = (uiTrack: UITrack) => mutateTrack(uiTrack, (t) => ({ ...t, selected: true }));
  const deselectTrack = (uiTrack: UITrack) => mutateTrack(uiTrack, (t) => ({ ...t, selected: false }));
  const allSelected = useMemo(() => tracks.every((t) => t.selected), [tracks]);
  const toggleAll = () =>
    setTracks(
      mutateWhere(
        tracks,
        (t) => ({ ...t, selected: !allSelected }),
        (t) => true
      )
    );

  const deleteSelected = async () => {
    for (const track of tracks) {
      if (track.selected) {
        console.log(track);
        await onDelete(track);
        await new Promise((r) => setTimeout(r, 50));
      }
    }
  };
  return { allSelected, toggleAll, deleteSelected, selectTrack, deselectTrack };
}
